import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { SharedModule } from './common/shared.module';
import { HTTP_INTERCEPTORS, provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';
import { AuthService } from './services/auth.service';
import { AngularFireModule } from '@angular/fire/compat';
import { AngularFireAuthModule } from '@angular/fire/compat/auth';
import { AngularFireStorageModule } from '@angular/fire/compat/storage';
import { environment } from '../environments/environment';
import { APIInterceptor } from './common/interceptors/api.interceptor';
import { AuthInterceptor } from './common/interceptors/auth.interceptor';
import { NgChartsModule } from 'ng2-charts';
import { provideMarkdown } from "ngx-markdown";
import { initializeApp, provideFirebaseApp } from '@angular/fire/app';
import { getStorage, provideStorage } from '@angular/fire/storage';
import { getAuth, provideAuth } from '@angular/fire/auth';
import { provideAnimationsAsync } from '@angular/platform-browser/animations/async';
import { providePrimeNG } from 'primeng/config';
import ApexTheme from 'src/apex-2-theme';
import { MessageService } from 'primeng/api';
import { ToastsV2Component } from './common/elements/toasts-v2/toasts-v2.component';
import { NotificationDrawerComponent } from "./common/elements/overlays/notification-drawer/notification-drawer.component";
import { DialogService } from 'primeng/dynamicdialog';
import { ButtonModule } from "primeng/button";
import { AiAssistantComponent } from "./ai-assistant/ai-assistant.component";

@NgModule({
    declarations: [AppComponent],
    bootstrap: [AppComponent],
    imports: [
    BrowserModule,
    AppRoutingModule,
    BrowserAnimationsModule,
    SharedModule,
    AngularFireModule.initializeApp(environment.firebase),
    AngularFireAuthModule,
    AngularFireStorageModule,
    NgChartsModule,
    ToastsV2Component,
    NotificationDrawerComponent,
    ButtonModule,
    AiAssistantComponent
],
    providers: [
        provideAnimationsAsync(),
        providePrimeNG({
            theme: {
                preset: ApexTheme,
                options: {
                    darkModeSelector: '',
                },
            },
        }),
        MessageService,
        AuthService,
        provideMarkdown(),
        {
            provide: HTTP_INTERCEPTORS,
            useClass: APIInterceptor,
            multi: true,
        },
        {
            provide: HTTP_INTERCEPTORS,
            useClass: AuthInterceptor,
            multi: true,
        },
        provideHttpClient(withInterceptorsFromDi()),
        provideFirebaseApp(() => initializeApp(environment.firebase),),
        provideStorage(() => getStorage()),
        provideAuth(() => getAuth()),
        DialogService
    ]
})
export class AppModule { }
